import { useEffect, type ReactNode } from "react";
import { MailBootScreen } from "@/features/boot/MailBootScreen";
import { useMailAuthReady } from "@/hooks/useMailAuthReady";

type Props = { children: ReactNode };

/** Pas d’appels API métier tant que le gate SSO n’a pas validé la session (doc SSO). */
export function MailAuthGate({ children }: Props) {
  const { state } = useMailAuthReady();

  useEffect(() => {
    if (state === "ready") {
      window.hideSuiteAuthModal?.();
      window.hideSuiteForbiddenModal?.();
      window.unlockSuiteAppShell?.();
    }
  }, [state]);

  if (state === "boot") {
    return <MailBootScreen label="Démarrage…" mode="loading" />;
  }

  if (state === "lost") {
    return <MailBootScreen label="Connexion requise" mode="status" />;
  }

  return <>{children}</>;
}
